
  import { Vue, Component, Prop } from "vue-property-decorator";

  interface Rows {
    [numberOfRow: number]: {
      ids: Set<string>,
      [blockName: string]: number | Set<string>,
    }
  }

  interface SetSizeArgs {
    id: string,
    blockName: string,
    index: number,
    minHeight: number,
  }

  interface GetBlockMinHeight {
    id: string,
    blockName: string,
    index: number,
  }

  @Component
  export default class ElementsSizeProvider extends Vue {
    @Prop({ type: Number, required: false, default: 245 }) readonly minCardWidth!: number;
    @Prop({ type: Number, required: false, default: 15 }) readonly horizontalGap!: number;

    offsetWidth: number = 0;
    rows: Rows = {};

    get elementsInRow(): number {
      if (this.offsetWidth === 0) {
        return 0;
      }

      const minCardWidth = this.minCardWidth;
      const horizontalGap = this.horizontalGap;

      const width = this.offsetWidth;
      const oneRowWidth = minCardWidth + horizontalGap + minCardWidth - 1;
      const oneRow = (width - oneRowWidth) <= 0;

      if (oneRow) {
        return 1;
      }

      const columns = 1 + (width - minCardWidth) / (minCardWidth + horizontalGap);
      return Math.floor(columns);
    }

    getNumberOfRow(index: number): number {
      if (index === 0) {
        return 1;
      }

      const elementsInRow = this.elementsInRow
      const ratio = index / elementsInRow;

      if (ratio === 0) {
        return 0;
      }

      if (ratio < 1) {
        return 1;
      }

      return 1 + Math.floor(ratio);
    }

    getBlockMinHeight({id, index, blockName }: GetBlockMinHeight): number {
      if (!this.elementsInRow) {
        return 0;
      }

      const numberOfRow = this.getNumberOfRow(index);

      if (!numberOfRow || !this.rows[numberOfRow]) {
        return 0;
      }

      if (!this.rows[numberOfRow].ids.has(id)) {
        this.rows = {};
        return 0;
      }

      return this.rows[numberOfRow][blockName] as number;
    }

    setSize({id, blockName, minHeight, index }: SetSizeArgs): void {
      this.offsetWidth = (this.$refs.cardsContainer as HTMLDivElement).offsetWidth;

      const numberOfRow = this.getNumberOfRow(index);

      if (numberOfRow === 0) {
        return;
      }

      if (!this.rows[numberOfRow]) {
        this.rows = {
          ...this.rows,
          [numberOfRow]: {
            ids: (new Set<string>()).add(id),
            [blockName]: minHeight,
          }
        }
        return;
      }

      const prevMinHeight = this.rows[numberOfRow][blockName] as number;
      const newMinHeight = prevMinHeight > minHeight ? prevMinHeight : minHeight;

      this.rows[numberOfRow] = {
        ...this.rows[numberOfRow],
        ids: this.rows[numberOfRow].ids.add(id),
        [blockName]: newMinHeight,
      }
    }
  }
